import { Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';
import { HomeAboutUsSectionCItem } from './components/home-about-us-section-c-item/home-about-us-section-c-item.component';

@Component({
  selector: 'app-home-about-us-section-c',
  templateUrl: './home-about-us-section-c.component.html',
  styleUrls: ['./home-about-us-section-c.component.scss']
})
export class HomeAboutUsSectionCComponent extends BaseComponent implements OnInit {
  constructor(public override responsive: ResponsiveService, public override transloco: TranslocoService) {
    super(responsive, transloco);
  }

  items: HomeAboutUsSectionCItem[];

  ngOnInit(): void {
    this.transloco.selectTranslateObject(
      'home.about_us.section_c.items'
    ).subscribe(result => {
      this.items = result;
    });
  }
}
